import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { SubscriptionRepository } from "../domain/SubscriptionRepository";
import { SubscriptionDomain } from "../domain/SubscriptionDomain";

export async function listSubscriptions(
  repository: SubscriptionRepository,
  companyId: string,
): Promise<VectiResult> {
  try {
    console.log("llamando a listSubscriptionsByCompany: " + companyId);
    const subscriptions = await repository.listSubscriptionsByCompany(companyId);
    let getActiveSubs = false;
    console.log("listReveniuSubscription", JSON.stringify(subscriptions));
    if (subscriptions && subscriptions.length > 0) {
      const subsFind = subscriptions.find((subscription) => (
        (subscription.subscription_status === SubscriptionDomain.registered) || subscription.subscription_status === SubscriptionDomain.payed) &&
        ((subscription.subscription_is_active === true) || (subscription.subscription_is_active === false && esHoy(subscription.subscription_creation_date))
        ));
      if (subsFind) {
        getActiveSubs = true;
      }
      console.log("subsFind", JSON.stringify(subsFind));
      console.log("getActiveSubs", JSON.stringify(getActiveSubs));
      if (getActiveSubs) {
        return new VectiResult(true, { subscription_end_date: subsFind?.subscription_end_date });
      } else {
        return new VectiResult(false, "no tiene activa");
      }

    } else {
      return new VectiResult(false, "no tiene activa");
    }
  } catch (error) {
    console.log("error listSubscriptions:" + error);
    return new VectiResult(false, "Error");
  }
}

function esHoy(fecha: Date) {
  const hoy = new Date();
  const fecha2 = new Date(fecha);
  console.log("fecha", fecha);
  console.log("fecha2", fecha2);
  console.log("hoy", hoy);
  return (
    new Date(fecha).getFullYear() === hoy.getFullYear() &&
    new Date(fecha).getMonth() === hoy.getMonth() &&
    new Date(fecha).getDate() === hoy.getDate()
  );
}

